<template>
  <div
    class="w-72 max-lg:bg-white max-lg:hidden max-lg:min-h-screen max-lg:px-8 max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:z-50"
    :class="{ 'max-lg:!block': filterState }"
  >
    <div class="hidden mt-6 mb-10 max-lg:!flex max-lg:justify-between">
      <h2 class="text-xl font-bold">{{ $t('page.filter') }}</h2>
      <button
        @click="$emit('closeFilter', true)"
        class="absolute right-5 rounded p-1.5 bg-[#F8F8F8] hover:bg-[#F0F0F0] ease-linear transition-all duration-150"
      >
        <IconClose></IconClose>
      </button>
    </div>
    <div class="divide-y-2 overflow-y-auto max-lg:h-[90vh]">
      <div class="mb-4">
        <div class="overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li v-if="!hideFilters.includes('currentHasDiscount')">
              <div class="flex items-center justify-between gap-2 text-red-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.discount') }}</p>
                <label for="has_discount" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="has_discount"
                    :checked="isTruthy(currentHasDiscount)"
                    @change="e => handleCheckbox(e, 'has_discount')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
            <li v-if="!hideFilters.includes('currentIsPromotion')">
              <div class="flex items-center justify-between gap-2 text-red-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.promotion') }}</p>
                <label for="in_promotion" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="in_promotion"
                    :checked="isTruthy(currentIsPromotion)"
                    @change="e => handleCheckbox(e, 'in_promotion')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
            <li v-if="!hideFilters.includes('currentForCredit')">
              <div class="flex items-center justify-between gap-2">
                <p class="font-bold max-md:font-sm uppercase text-main-color">
                  {{ $t('page.onCredit') }}
                </p>
                <label for="for_credit" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="for_credit"
                    :checked="isTruthy(currentForCredit)"
                    @change="e => handleCheckbox(e, 'for_credit')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
            <li v-if="!hideFilters.includes('currentIsNew')">
              <div class="flex items-center justify-between gap-2 text-green-500">
                <p class="font-bold max-md:font-sm uppercase">{{ $t('page.new') }}</p>
                <label for="new" class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    id="new"
                    :checked="isTruthy(currentIsNew)"
                    @change="e => handleCheckbox(e, 'is_new')"
                    class="sr-only peer"
                  />
                  <div
                    class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
                  ></div>
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!hideFilters.includes('currentCategory')" class="my-5 py-5">
        <p class="font-semibold text-xl mb-4">{{ $t('page.categories') }}</p>
        <div class="h-96 overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentCategory == null }"
                :to="{
                  name: 'stores',
                  query: {
                    category: null,
                    subscription: currentSubscription,
                    is_vip: isVip,
                    ordering: currentSort,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    for_credit: currentForCredit,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >{{ $t('page.all') }}</router-link
              >
            </li>
            <li v-for="category in $store.mallCategories" :key="category.id">
              <div class="flex items-center justify-between gap-5">
                <router-link
                  class="text-main-color text-base font-semibold hover:text-accent-color"
                  :class="{ '!text-accent-color': category.id == currentCategory }"
                  :to="{
                    name: 'stores',
                    query: {
                      category: category.id,
                      subscription: currentSubscription,
                      is_vip: isVip,
                      ordering: currentSort,
                      is_new: currentIsNew,
                      in_promotion: currentIsPromotion,
                      for_credit: currentForCredit,
                      has_discount: currentHasDiscount,
                      location: location,
                    },
                  }"
                  >{{ category.name }}
                  <span class="text-red-400 text-sm">({{ category.stores_count }})</span>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="!hideFilters.includes('currentSubscription')" class="my-5 py-5">
        <p class="font-semibold text-xl mb-4">{{ $t('page.status') }}</p>
        <div class="overflow-y-scroll fltrs">
          <ul class="space-y-3 row-list">
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == null }"
                :to="{
                  name: 'stores',
                  query: {
                    category: currentCategory,
                    subscription: null,
                    is_vip: isVip,
                    ordering: currentSort,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    for_credit: currentForCredit,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >{{ $t('page.all') }}</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 1 }"
                :to="{
                  name: 'stores',
                  query: {
                    category: currentCategory,
                    subscription: 1,
                    is_vip: isVip,
                    ordering: currentSort,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    for_credit: currentForCredit,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >GOLD</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 2 }"
                :to="{
                  name: 'stores',
                  query: {
                    category: currentCategory,
                    subscription: 2,
                    is_vip: isVip,
                    ordering: currentSort,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    for_credit: currentForCredit,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >SILVER</router-link
              >
            </li>
            <li>
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': currentSubscription == 3 }"
                :to="{
                  name: 'stores',
                  query: {
                    category: currentCategory,
                    subscription: 3,
                    is_vip: isVip,
                    ordering: currentSort,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    for_credit: currentForCredit,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >BRONZE</router-link
              >
            </li>
            <li v-if="!hideFilters.includes('isVip')">
              <router-link
                class="text-main-color text-base font-semibold hover:text-accent-color"
                :class="{ '!text-accent-color': isVip == 'true' }"
                :to="{
                  name: 'stores',
                  query: {
                    category: currentCategory,
                    subscription: currentSubscription,
                    is_vip: isVip == 'true' ? null : true,
                    ordering: currentSort,
                    is_new: currentIsNew,
                    in_promotion: currentIsPromotion,
                    for_credit: currentForCredit,
                    has_discount: currentHasDiscount,
                    location: location,
                  },
                }"
                >VIP</router-link
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="my-3 py-3">
        <button
          @click="clearFilter"
          class="bg-accent-color w-full py-2 rounded-md text-white hover:bg-main-color"
        >
          {{ $t('page.clear') }}
        </button>
      </div>
    </div>
  </div>
  <div
    class="fixed inset-0 hidden bg-gray-800 bg-opacity-50"
    :class="{ 'max-lg:!flex': filterState }"
  ></div>
</template>

<script>
import _debounce from 'lodash.debounce';
import IconArrowLeft from '@icons/IconArrowLeft.vue';
import IconClose from '@icons/IconClose.vue';

export default {
  name: 'MallStoreSide',
  components: {
    IconArrowLeft,
    IconClose,
  },
  props: {
    filterState: {
      type: Boolean,
      default: false,
    },
    hideFilters: {
      type: Array,
      default: () => [],
      required: false,
    },
    currentCategory: {
      type: [Number, String],
      default: undefined,
    },
    currentSubscription: {
      type: [Number, String],
      default: undefined,
    },

    isVip: {
      type: [Boolean, String],
      default: undefined,
    },

    currentIsNew: {
      type: [Boolean, String],
      default: undefined,
    },
    currentIsPromotion: {
      type: [Boolean, String],
      default: undefined,
    },
    currentForCredit: {
      type: [Boolean, String],
      default: undefined,
    },
    currentHasDiscount: {
      type: [Boolean, String],
      default: undefined,
    },
    currentSort: {
      type: [Number, String],
      default: undefined,
    },

    location: {
      type: [Number, String],
      default: undefined,
    },
  },

  data() {
    return {};
  },

  methods: {
    isTruthy(value) {
      return value === true || value === 'true' || value === 1 || value === '1';
    },

    cleanQuery(query) {
      Object.keys(query).forEach(key => {
        const value = query[key];

        if (
          value === undefined ||
          value === null ||
          value === '' ||
          value === false ||
          value === 'false' ||
          (Array.isArray(value) && value.length === 0)
        ) {
          delete query[key];
        }
      });

      return query;
    },

    clearFilter() {
      this.$router.push({
        name: 'stores',
        query: {},
      });
    },

    handleCheckbox(e, name) {
      const query = this.cleanQuery({
        category: this.currentCategory,
        subscription: this.currentSubscription,
        is_vip: this.isVip,
        ordering: this.currentSort,
        is_new: this.currentIsNew,
        in_promotion: this.currentIsPromotion,
        for_credit: this.currentForCredit,
        has_discount: this.currentHasDiscount,
        location: this.location,
      });

      if (e.target.checked) {
        query[name] = true;
      } else {
        delete query[name];
      }

      this.$router.push({
        name: 'stores',
        query,
      });
    },
  },
  mounted() {},
};
</script>
